import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Title = styled.div(
  ({theme}) => css`
    color: ${theme.colors.contentPrimary};

    ${theme.respondUpTo(
      'lg',
      css`
        ${theme.typography.headlineMedium};
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        ${theme.typography.headlineLarge};
      `
    )}
  `
);
